const jQ = jQuery.noConflict();
const header = jQ('.main-header');
const banner = jQ('.main-banner');
// left: 37, up: 38, right: 39, down: 40,
// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
const keys = [37, 38, 39, 40];

/*function preventMouseWheel(e) {
    e = e || window.event;
    e.returnValue = false;
}*/

function keydown(e) {
    for (let i = keys.length; i--;) {
        if (e.keyCode === keys[i]) {
            preventDefault(e);
            return;
        }
    }
}

/*function wheel(e) {
    preventMouseWheel(e);
}
*/
function disableScroll() {
/*    if (window.addEventListener) {
        window.addEventListener('DOMMouseScroll', wheel, false);
    }*/
   // window.onmousewheel = document.onmousewheel = wheel;
    document.onkeydown = keydown;
}

function enable_scroll() {
/*    if (window.removeEventListener) {
        window.removeEventListener('DOMMouseScroll', wheel, false);
    }*/
    window.onmousewheel = document.onmousewheel = document.onkeydown = null;
}
let scrolled = false;
function animatePage() {
    if (scrolled === false) {
        jQ('html, body').animate({
            scrollTop: banner.height() + 1,
        }, 1200, () => { enable_scroll(); });
        scrolled = true;
    }
}
function scrollFunc() {
    jQ(window).on('scroll resize', () => {
        const bannerHeight = banner.height();
        if (jQ(window).scrollTop() >= bannerHeight) {
            header.addClass('sticky');
            banner.addClass('static')
        } else if ( jQ(window).scrollTop() < bannerHeight && header.hasClass('sticky')) {
            header.removeClass('sticky');
            banner.removeClass('static');
            header.find('.open').removeClass('open');
            header.css('transform', '');
            jQ('#page').css('transform', '');
        }
    });
}
function setOverlay(){
    var isshow = sessionStorage.getItem('isshow');
    if (isshow == null) {
        sessionStorage.setItem('isshow', 1);
    }
};
function scrollBanner() {
    const path = window.location.href;
    const loc = path.indexOf("#");
    var isshow = sessionStorage.getItem('isshow');
    if (isshow == null) {
        sessionStorage.setItem('isshow', 1);
        if (banner.length && loc === -1) {
            disableScroll();
            jQ(window).on('load', () => {
                jQ(window).one('scroll', () => {
                    animatePage();
                });
            });

            scrollFunc();
        } else if (banner.length) {
            scrollFunc();
        }
    } else{
        if (banner.length && loc === -1){
            jQ('html, body').animate({
                scrollTop: banner.height() + 1,
            }, 1200);
            scrollFunc();
        } else if (banner.length){
            scrollFunc();
        }

    }

}

export default scrollBanner;
